import styled from 'styled-components'
import { tokens } from '@arvoreeducacao/bonsai-ds'

export const Content = styled.div`
  min-height: 100vh;
  width: 100vw;
  padding: 20px 16px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`

export const StyledImage = styled.img`
  width: 100%;
  height: auto;
  max-width: 144px;
  max-height: 144px;
  margin-bottom: 32px;
`

export const Title = styled.h2`
  display: block;
  margin-bottom: 16px;
  max-width: 378px;
  text-align: center;
  color: ${tokens.colors.black6};
`

export const Text = styled.p`
  font-size: 16px;
  margin-top: 0px;
  max-width: 378px;
  margin-bottom: 30px;
  text-align: center;
  line-height: 33px;
  color: ${tokens.colors.black5};
`

export const AlertBox = styled.div`
  display: flex;
  background-color: ${tokens.colors.yellow1};
  border-radius: ${tokens.radius.large};
  max-width: 420px;
  padding: 16px;
  align-items: center;
  margin-bottom: 32px;

  span {
    margin-right: 9.3px;
  }

  p {
    margin: 0;
    font-size: 12.8px;
    line-height: 18px;
  }

  label {
    text-decoration: underline;
    cursor: pointer;
  }
`
